import * as React from 'react';
import { prop } from '../../../utilities';
import styled from 'styled-components';
import { rem } from 'polished';

export enum AlertType {
  Warning,
  Error,
  Success,
}

interface Props {
  message: string;
  type: AlertType;
  closeAlert?: () => void;
  hideX?: boolean;
  style?: React.CSSProperties;
}

export class Alert extends React.Component<Props> {
  public render() {
    let AlertLogo = '/images/errors/error.svg';
    let CancelLogo = '/images/errors/cancel.svg';

    switch (this.props.type) {
      case AlertType.Warning: {
        AlertLogo = '/images/errors/warning/error.svg';
        CancelLogo = '/images/errors/warning/cancel.svg';
        break;
      }
      case AlertType.Error: {
        AlertLogo = '/images/errors/error/error.svg';
        CancelLogo = '/images/errors/error/cancel.svg';
        break;
      }
      case AlertType.Success: {
        AlertLogo = '/images/done.svg';
        CancelLogo = '/images/errors/success/cancel.svg';
        break;
      }
    }

    const { message } = this.props;

    return (
      <AlertBox
        type={this.props.type}
        style={{
          ...this.props.style,
        }}
      >
        {this.props.closeAlert && this.props.hideX !== true ? (
          <CancelIcon onClick={this.props.closeAlert} src={CancelLogo} />
        ) : null}
        <ContentHolder>
          <ErrorIcon onClick={this.props.closeAlert} src={AlertLogo} />
          <AlertMessage type={this.props.type}> {message} </AlertMessage>
        </ContentHolder>
      </AlertBox>
    );
  }
}

const CancelIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-top: 2px;
  float: right;
  cursor: pointer;
`;

const ContentHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ErrorIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 15px;
`;

const AlertMessage: any = styled.p`
  width: 90%;
  margin: 0;
  padding: 0;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  color: ${(props: any) => {
    switch (props.type) {
      case AlertType.Warning: {
        return (
          prop(props, 'theme.alerts.warning.borderColor') || 'rgb(247,158,27)'
        );
      }
      case AlertType.Error: {
        return (
          prop(props, 'theme.alerts.error.borderColor') || 'rgb(235,103,108)'
        );
      }
      case AlertType.Success: {
        return (
          prop(props, 'theme.alerts.success.borderColor') || 'rgb(165,187,162)'
        );
      }
    }
  }};
`;

const AlertBox: any = styled.div`
  background-color: ${(props: any) => {
    switch (props.type) {
      case AlertType.Warning: {
        return (
          prop(props, 'theme.alerts.warning.backgroundColor') ||
          'rgb(247,158,27, 0.3)'
        );
      }
      case AlertType.Error: {
        return (
          prop(props, 'theme.alerts.error.backgroundColor') ||
          'rgb(235,103,108,0.3)'
        );
      }
      case AlertType.Success: {
        return (
          prop(props, 'theme.alerts.success.backgroundColor') ||
          'rgb(165,187,162,0.3)'
        );
      }
    }
  }};
  padding: 10px 20px;
  width: 100%;
  border-radius: ${props => prop(props, 'theme.alerts.borderRadius') || '4px'};
  display: inline-block;
  margin: ${rem(32)} 0;
`;
